<span class="wallSort__label"
      *ngIf="sortLabelVisible">
  Sort by:
</span>
<mat-form-field class="wallSort__select compact ongray">
  <mat-select [formControl]="sortSelectControl">
    <mat-option *ngFor="let sort of sortByOptions"
                [value]="sort.value">
      {{sort.viewValue}}
    </mat-option>
  </mat-select>
  <button matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="directionChangeClicked($event)"
          class="fa--gray">
    <mat-icon fontSet="far"
              [fontIcon]="sortIcon"></mat-icon>
  </button>
</mat-form-field>
